// Sets a JS Date to +0h UTC timezone and to the start of day (00:00:00.000Z), without converting the date part
export const toZeroTimeAndTZ = (date: Date): Date => {
  return new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0),
  );
};
